export let priceConvertation = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}